export type ProjectMedia =
  | { kind: 'image'; src: string; alt: string }
  | { kind: 'video'; src: string; alt: string }
  | { kind: 'quote'; text: string };

export type Project = {
  slug: string;
  sort?: number;
  title: string;
  date: string;          // "2024 | 03"
  category: string;
  with_: string;
  role: string;
  distinctions: string;
  description: string;
  url: string;
  image: string;
  media: ProjectMedia[];
};

/**
 * Projects live as data.json files under public/works/<slug>/, next to
 * their media, and are aggregated by the /api/projects route.
 */
export async function fetchProjects(): Promise<Project[]> {
  try {
    const response = await fetch('/api/projects');
    if (!response.ok) throw new Error(`Failed to load projects: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('Error loading projects:', error);
    return [];
  }
}
